// SAMPLING ORDER OPTIONS: the choices a grower makes when a Map Soil order is placed on the
// confirmation pop-up, for a preset click and for a customized design alike — saved on the SS2 work
// order (`config.

export const DEPTH_IN = { default: 8, min: 1, max: 12 } as const;
export const CORES = { default: 6, min: 4, max: 8 } as const;
export const CORE_LINE_FT = { default: 20, min: 5, max: 200 } as const;

const clampInt = (v: unknown, lo: number, hi: number, dflt: number): number => {
  // absent (null/undefined/blank) = the default; `Number(null)` is 0, which would silently clamp to the floor
  if (v == null || (typeof v === "string" && v.trim() === "")) return dflt;
  const n = Math.round(Number(v));
  if (!Number.isFinite(n)) return dflt;
  return Math.max(lo, Math.min(hi, n));
};
export const clampDepthIn = (v: unknown): number =>
  clampInt(v, DEPTH_IN.min, DEPTH_IN.max, DEPTH_IN.default);
export const clampCores = (v: unknown): number =>
  clampInt(v, CORES.min, CORES.max, CORES.default);
export const clampCoreLineFt = (v: unknown): number =>
  clampInt(v, CORE_LINE_FT.min, CORE_LINE_FT.max, CORE_LINE_FT.default);

/*
 *
 * Nothing looser: this number receives sampling-crew texts.
 */
export function normalizeUsPhone(
  raw: string | null | undefined,
): string | null {
  const digits = String(raw ?? "").replace(/\D/g, "");
  const ten =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (ten.length !== 10) return null;
  if (/^[01]/.test(ten) || /^[01]/.test(ten.slice(3))) return null;
  return `+1${ten}`;
}

/* * "(555) 123-4567" for display, from anything `normalizeUsPhone` accepts; the raw string when it doesn't */
export function formatUsPhone(raw: string | null | undefined): string {
  const e = normalizeUsPhone(raw);
  if (!e) return String(raw ?? "");
  const t = e.slice(2);
  return `(${t.slice(0, 3)}) ${t.slice(3, 6)}-${t.slice(6)}`;
}

/* * the order-time gate: what would make "Save & Order" wrong to press */
export function orderOptionsProblem(o: {
  notifyPhone?: string | null;
}): string | null {
  const raw = (o.notifyPhone ?? "").trim();
  if (raw && !normalizeUsPhone(raw))
    return "Enter a valid US phone number for sampling notifications (10 digits), or leave it blank.";
  return null;
}
